import { MultiLineFilters } from "../MultiLineFilter";

const ALL_FILTERS_IDS = "all-filters-ids";

const buildFilterSessionId = (filteredUniqKey: string, bindingPath: string): string =>
    `filters-${filteredUniqKey}-${bindingPath}`;

export const setFilter = (filteredUniqKey: string, bindingPath: string, value: string): void => {
    window.sessionStorage.setItem(buildFilterSessionId(filteredUniqKey, bindingPath), value);
    addToAllFiltersSessionIds(filteredUniqKey, bindingPath);
};

export const removeFilter = (filteredUniqKey: string, bindingPath: string): void => {
    window.sessionStorage.removeItem(buildFilterSessionId(filteredUniqKey, bindingPath));
    removeFromAllFiltersSessionIds(filteredUniqKey, bindingPath);
};

export const safeGetFilter = (filteredUniqKey: string, bindingPath: string): MultiLineFilters | undefined => {
    try {
        return JSON.parse(
            window.sessionStorage.getItem(buildFilterSessionId(filteredUniqKey, bindingPath)) ?? "undefined"
        ) as MultiLineFilters;
    } catch {
        return undefined;
    }
};

const addToAllFiltersSessionIds = (filteredUniqKey: string, bindingPath: string): void => {
    const filterSessionId = buildFilterSessionId(filteredUniqKey, bindingPath);
    const allFiltersSessionIds = getAllFiltersSessionIds()
        .filter(it => it !== filterSessionId)
        .concat(filterSessionId);

    window.sessionStorage.setItem(ALL_FILTERS_IDS, JSON.stringify(allFiltersSessionIds));
};

const removeFromAllFiltersSessionIds = (filteredUniqKey: string, bindingPath: string): void => {
    const allFiltersSessionIds = getAllFiltersSessionIds().filter(
        it => it !== buildFilterSessionId(filteredUniqKey, bindingPath)
    );

    window.sessionStorage.setItem(ALL_FILTERS_IDS, JSON.stringify(allFiltersSessionIds));
};

const getAllFiltersSessionIds = (): string[] => {
    try {
        return JSON.parse(window.sessionStorage.getItem(ALL_FILTERS_IDS) ?? "[]") as string[];
    } catch {
        return [];
    }
};

export const clearAllFiltersSessions = (): void => {
    for (const filterSessionId of getAllFiltersSessionIds()) {
        window.sessionStorage.removeItem(filterSessionId);
    }
    window.sessionStorage.removeItem(ALL_FILTERS_IDS);
};
